import React from 'react';

const ContentPlayersTableHeader = ({ headerStyle }) => (
  <div className={headerStyle}>
    <div>#</div>
    <div>Player</div>
    <div>POS</div>
    <div>B/T</div>
    <div>HT</div>
    <div>WT</div>
    <div>YOB</div>
  </div>
);

export default ContentPlayersTableHeader;
